import { render, staticRenderFns } from "./WizardButtons.vue?vue&type=template&id=79b100f1&"
import script from "./WizardButtons.vue?vue&type=script&lang=js&"
export * from "./WizardButtons.vue?vue&type=script&lang=js&"
import style0 from "./WizardButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports